const ASSET_ID_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function describeAssetIdValue(value: unknown): string {
  if (Array.isArray(value)) {
    return `array(${value.length})`;
  }
  if (value === null) {
    return 'null';
  }
  return typeof value;
}

function buildInvalidAssetIdMessage(context: string, value: unknown, details?: Record<string, unknown>): string {
  const suffix = details ? ` ${JSON.stringify(details)}` : '';
  return `[AssetIdContract] ${context} expected assetId to be a string, received ${describeAssetIdValue(value)}.${suffix}`;
}

function buildInvalidAssetIdShapeMessage(context: string, value: string, details?: Record<string, unknown>): string {
  const suffix = details ? ` ${JSON.stringify(details)}` : '';
  return `[AssetIdContract] ${context} expected assetId to be a UUID string, received \"${value}\".${suffix}`;
}

export function normalizeOptionalAssetId(
  value: unknown,
  context: string,
  details?: Record<string, unknown>,
): string | undefined {
  if (value == null) {
    return undefined;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return undefined;
    }
    if (!ASSET_ID_UUID_RE.test(trimmed)) {
      console.warn(buildInvalidAssetIdShapeMessage(context, trimmed, details));
      return undefined;
    }
    return trimmed;
  }

  const error = new Error(buildInvalidAssetIdMessage(context, value, details));
  console.error(error.message, {
    ...details,
    value,
    stack: error.stack,
  });
  return undefined;
}

export function requireNullableAssetId(
  value: unknown,
  context: string,
  details?: Record<string, unknown>,
): string | null {
  if (value == null) {
    return null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    if (!ASSET_ID_UUID_RE.test(trimmed)) {
      console.warn(buildInvalidAssetIdShapeMessage(context, trimmed, details));
      return null;
    }
    return trimmed;
  }

  throw new Error(buildInvalidAssetIdMessage(context, value, details));
}